import { useRouter } from 'next/router';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useIframeRouter } from '@/hooks';
import { AlertModal } from '../../UI';
import { RequestErrorModalProps } from './RequestErrorModal.types';

export const RequestErrorModal: FC<RequestErrorModalProps> = ({
  errorDetail,
  redirectTo,
  onConfirm,
  onClose,
  locationPhone,
}) => {
  const { t } = useTranslation();
  const router = useRouter();
  const { routerReplace } = useIframeRouter();
  const { countryCode, locationId } = router.query as { countryCode: string; locationId: string };

  const redirect = () => {
    switch (redirectTo) {
      case 'home':
        return routerReplace(`/${countryCode}`);
      case 'branchOffice':
        return routerReplace(`/${countryCode}/sucursal/${locationId}`);
      case 'reload':
        return router.reload();
      case 'previous':
        return router.back();
      default:
        return undefined;
    }
  };

  const close = () => onClose?.();
  const confirm = () => {
    if (redirectTo) {
      redirect();
    } else {
      onConfirm?.();
    }
    onClose?.();
  };

  return (
    <AlertModal
      hide={close}
      title={`${t('ERRORS.ERROR')}`}
      description={`${t('WE_ARE_SORRY_AN_ERROR_OCCURRED')}`}
      errorDetail={errorDetail}
      onConfirm={confirm}
      phoneLink={locationPhone ? `tel:${locationPhone}` : undefined}
    />
  );
};
